import {InfoTooltip} from '@wandb/components';
import React from 'react';

/**
 * Takes the place of a filter row's checkbox while the row cannot be applied.
 * The icon is focusable and shows the tooltip on focus; `id` lets the row
 * point at it with aria-describedby.
 */
export const InvalidFilterTooltip = ({id}: {id: string}) => (
  <InfoTooltip id={id} variant="warning" aria-label="Invalid filter">
    A true/false value cannot be ordered. Choose an operator other than &lt;,
    &le;, &gt; or &ge;.
  </InfoTooltip>
);
